import React, { useState } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import Input from "components/Input";
import { useMutation } from "@apollo/client";
import { CHANGE_CONTACT } from "graphql/service";
import { Head, Container, Footer } from "./styles";
import ModalVerification from "screens/ModalVerification";

const ModalNewEmailAddress = ({
  hidden,
  isOpen,
  setIsOpen,
  refetch,
  token
}) => {

  const [verificationIsOpen, setVerificationIsOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [changeContact, { loading }] = useMutation(CHANGE_CONTACT, {
    onCompleted: (data) => {
      setIsOpen(false);
      setVerificationIsOpen(true);
    },
    onError: (error) => {
      setEmailError(true);
      let messages = [];

      if (error.graphQLErrors?.length > 0) {
        messages = error.graphQLErrors.map(err => err.message);
      } else if (error.networkError?.result?.errors) {
        messages = error.networkError.result.errors.map(err => err.message);
      } else if (error.networkError) {
        messages = [error.networkError.message];
      }

      if (messages?.length > 0) {
        setErrorMessage(messages.join(", "));
      }
    }
  });

  const handleContinue = () => {
    if (email.trim() === "" || !email.includes("@")) {
      setEmailError(true);
      return;
    }
    changeContact({
      variables: {
        input: {
          contactType: "EMAIL",
          sessionToken: token,
          newValue: email
        }
      }
    });
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        setClose={() => {
          setIsOpen(false);
          setEmail("");
          setEmailError(false);
          setErrorMessage("");
        }}
        className="modal-success"
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>
          Enter New Email Address
        </Head>
        <Container>
          <Input
            title="EMAIL ADDRESS"
            required
            error={emailError}
            errorMessage={errorMessage}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (emailError) {
                setEmailError(false);
              }
            }}
            additionalstyle={`
              width: 100%;
            `}
          />
        </Container>
        <Footer>
          <Button
            success
            additionalstyle={`
              width: 97px;
            `}
            onClick={handleContinue}
            data-loading={loading}
          >
            {loading ? null : "Continue"}
          </Button>
        </Footer>
      </MainModal>
      <ModalVerification
        isOpen={verificationIsOpen}
        setClose={() => {
          setVerificationIsOpen(false);
          setEmail("")
        }}  
        refetch={refetch}
        token={token}
        email={email}
      />
    </>
  );
};

export default ModalNewEmailAddress;